import * as Raven from "raven-js";
import { isDevelopment } from "config";
import { SHOW_MODAL } from "../../Modals/types";

import config from "./config";
import { maskSensitiveInfoWithLoanAppContext } from "./masks";

const isDev = isDevelopment();
const { sentryDSN, options } = config;

export const setTagsContext = tags => {
  if (Raven.isSetup()) {
    Raven.setTagsContext(tags);
  }
};

// Send report to Sentry
export const logException = (exception, context = {}) => {
  if (Raven.isSetup()) {
    Raven.captureException(exception, {
      extra: context,
    });
  }
  // eslint-disable-next-line no-unused-expressions,no-console
  window.console && console.error && console.error(exception);

  return {
    modalType: "EXCEPTION_ERROR",
    modalParams: {},
    type: SHOW_MODAL,
  };
};

// Catch rejected promises that do not have a rejection handler
const handleRejections = (ev: any) => {
  const message = "Unhandled rejection error";
  let context = {};

  if (ev && ev.reason && ev.reason.meta) {
    context = ev.reason.meta;
  } else if (ev && ev.reason && ev.reason.message) {
    context = { message: ev.reason.message };
  } else if (ev && ev.message) {
    context = { message: ev.message };
  }

  logException(message, context);
};

// Capture user session details
export const setUserContext = user => {
  if (Raven.isSetup()) {
    Raven.setUserContext(user);
  }
};

// set/clear loan app context used to identify and mask sensitive info before logging
export const setLoanAppContextForMaskingLogs = loanApp => {
  if (Raven.isSetup()) {
    Raven.setDataCallback(maskSensitiveInfoWithLoanAppContext(loanApp));
  }
};
export const clearLoanAppContextForMaskingLogs = () => {
  if (Raven.isSetup()) {
    Raven.setDataCallback(maskSensitiveInfoWithLoanAppContext());
  }
};

// Initialize logging, add listener to handle uncaught promises
export const initLogging = () => {
  if (!Raven.isSetup() && !isDev) {
    Raven.config(sentryDSN, options)
      .setDataCallback(maskSensitiveInfoWithLoanAppContext()) // app code sets ctx later as needed
      .install();
    window.addEventListener("unhandledrejection", handleRejections);

    if (window.missingEnvVars) {
      logException(`Missing env vars ${window.missingEnvVars.join(", ")}`);
    }
  } else if (window.missingEnvVars) {
    throw new Error(`Missing env vars ${window.missingEnvVars.join(", ")}`);
  }
};

// Clear user data, remove event listener
export const removeLogging = () => {
  if (Raven.isSetup()) {
    Raven.setUserContext().setDataCallback(data => data); // remove masking entirely
    window.removeEventListener("unhandledrejection", handleRejections);
  }
};
